import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import CustomerNav from "./CustomerNav";

import routes from "./customerRoutes";

class Customer extends Component {
	render() {
		return (
			<div className="full_body_container">
				<div className="sub_nav_wrapper">
					<div className="hbs-container-admin-nav">
						<CustomerNav />
					</div>
				</div>
				<main className="content_wrapper">{<Switch>{routes.map((route, i) => <Route key={i} {...route} />)}</Switch>}</main>
			</div>
		);
	}
}

export default Customer;



// WEBPACK FOOTER //
// ./src/components/customer/Customer.js